angular.module('filters').filter('parseFloat', function() {
  return function(data) {
    return parseFloat(data);
  };
});
